import { Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";

type ToastProps = {
  message: string;
  duration?: number;
  success: boolean;
};

export default function Toast({ message, duration, success }: ToastProps) {
  const [isShowing, setIsShowing] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShowing(false);
    }, duration || 3000);

    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Transition
      appear={true}
      as={Fragment}
      show={isShowing}
      enter="transition ease-out duration-200 transform"
      enterFrom="opacity-0 -translate-y-12"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-out duration-200 transform"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-12"
    >
      <div
        className={`text-xl border-2 border-black text-gray-800 top-4 md:top-16 2xl:top-20
                   font-semibold mx-auto w-fit px-8 py-4 rounded-full
                   absolute inset-x-0 ${
                     success ? "bg-green-400/95" : "bg-red-500/95"
                   }`}
      >
        {message}
      </div>
    </Transition>
  );
}
